import React from "react";
import { Card, Typography, Button } from "@ann/web-components";
import { CardInner, TextBlock, ButtonWrap } from "./OpenDocumentCard.styled";

const OpenDocumentCard = ({ title, description, onOpenDocument }) => (
  <Card>
    <CardInner>
      <TextBlock>
        <Typography category="title" size="small" weight="bold" color="neutral-black">
          {title}
        </Typography>
        {description ? (
          <Typography category="body" size="medium" weight="regular" color="body">
            {description}
          </Typography>
        ) : null}
      </TextBlock>
      <ButtonWrap>
        <Button
          label="Open document"
          type="primary"
          size="medium"
          onClick={onOpenDocument}
          pill={true}
        />
      </ButtonWrap>
    </CardInner>
  </Card>
);

export default OpenDocumentCard;
